import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { useAuth } from '@/auth/useAuth';
import { ROUTES } from '@/constants/routes';
import { LoadingLayout } from '@/layouts/LoadingLayout';

/**
 * Redirects unauthenticated users to login — never to a blank or error screen
 * (docs/development/FrontendGuidelines.md §6.3). The attempted location is preserved in `state.from` so login
 * can send the user back where they meant to go.
 */
export function ProtectedRoute() {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) return <LoadingLayout />;

  if (!isAuthenticated) {
    return <Navigate to={ROUTES.login} state={{ from: location }} replace />;
  }

  return <Outlet />;
}
